import React, { useState } from 'react';
import './AboutUsBody.css';
import { AnimatedSection } from '../../AnimatedSection';

const AboutUsBody = ({ videoTitle, videoDescription, videoUrl }) => {

    return (

        <section>
            <div className=" container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-5xl text-white text-right font-bold uppercase md:hidden">
                    About <br /> Us
                </div>
                <div className='text-left w-1/2 text-white content-description hidden md:block'>
                    <p>GAME 7 is a multi-platform sports and entertainment brand underscoring the journey to success through content, community, experiences, and consumer products inspired by the hunger needed to succeed in life's pivotal GAME 7-like moments. Co-founded by Mark Messier, Danny DeVito, Isaac Chera, and Mat Vlasic, GAME 7 aims to inspire all to rise to high-stake challenges for the opportunity of greatness.</p>
                </div>
                <div className='pt-16 md:pt-96 pb-32 md:pb-96'>
                    <div className='w-full relative flex items-center justify-center mt-20 '>
                        <img
                            src="./aboutus_data/Component 30 (1).png"
                            alt="Big Circle"
                            class="absolute animate-rotate-slow z-0"
                            style={{ width: '90%' }}
                        />

                        <img
                            src="./aboutus_data/Vector.svg"
                            alt="Medium Circle"
                            class="absolute  animate-rotate-slow-reverse z-10"
                            style={{ width: '70%' }}
                        />

                        <div className='flex flex-col justify-center items-center gap-3 md:gap-9' style={{ width: '100%' }}>

                            <img
                                src="./aboutus_data/Vectortop.svg"
                                alt="Small Circle"
                                class="relative  z-20"
                                style={{ width: '22%' }}
                            />

                            <img
                                src="./aboutus_data/Vectorbottom.svg"
                                alt="Small Circle"
                                class="relative  z-20"
                                style={{ width: '27%' }}
                            />
                        </div>
                    </div>
                </div>

                <AnimatedSection>
                    <div className='text-center  text-white content-description flex justify-center items-center md:hidden'>
                        <p>GAME 7 is a multi-platform sports and entertainment brand underscoring the journey to success through content, community, experiences, and consumer products inspired by the hunger needed to succeed in life's pivotal GAME 7-like moments. Co-founded by Mark Messier, Danny DeVito, Isaac Chera, and Mat Vlasic, GAME 7 aims to inspire all to rise to high-stake challenges for the opportunity of greatness.</p>
                    </div>
                </AnimatedSection>

                <AnimatedSection>
                    <div className='text-5xl text-center  p-20 text-white  flex justify-center items-center md:hidden'>
                        <p className='uppercase' style={{ zIndex: 10 }} >
                            When the crowd gets louder, we’re part of it.
                        </p>
                    </div>
                </AnimatedSection>
                <div className='hidden md:block'>
                    <img
                        src="./aboutus_data/3.png"
                        alt="Small Circle"
                    />
                </div>

            </div>
            <div className='flex justify-center items-end md:hidden'  style={{ zIndex: -10 }}>
                <img
                    src="./aboutus_data/Dwight Clark - The Catch 2.png"
                    alt="Small Circle"
                />

                <img
                    src="./aboutus_data/Group 528 1.png"
                    alt="Medium Circle"
                    class="absolute animate-up-down z-10"
                />
            </div>
            <div
                className="flex flex-col justify-center items-center p-10 gap-10 text-white hidden md:flex"
                style={{
                    backgroundColor: "#1e1e1e",
                    fontFamily: "SimplonMonoMediumRegular",
                    fontSize: "18px",
                }}
            >
                <div className="text-white text-center">
                    @2024 G7 IP Holdings, LLC. All Rights Reserved
                </div>
                <div className="text-white">
                    <a href="mailto:info@game7.com" className="underline">info@game7.com</a>
                </div>
            </div>
        </section>
    );
};

export default AboutUsBody;
